import { parseJson } from "../safeParse/parseJson"
import getDefaultSupportEmail from "./getDefaultSupportEmail"

export const defaultStoreMeta: any = {
  theme: {
    color_primary: '#000000',
    color_text: '#000000',
    border_radius: 8,
    container_color: "#ffffff"
  },
  about: {
    content: "",
    bg_image: "",
    bg_mode: "",
    bg_width: "",
    bg_height: "",
    bg_color: "",
    font_name: "",
    font_url: "",
    color: "",
  },
  grid_products: 5,
  test_store: false,
  product_card_text_color: '', // ok
  shown_preview_colors: true,
  btn_view_product_bg_color: '', // ok
  btn_view_product_text_color: '#ffffff',
  card_product: 'primary',
  products: [],

  enabled_banner_carousel: false,
  banner_bg_color: '',
  banner: {
    url: '',
    ext: '',
    disabled: false,
    width: 2000,
    height: 2000,
  },
  banner_mobile: {
    url: '',
    ext: '',
    disabled: false,
    width: 2000,
    height: 2000,
  },
  banner_1920x1080: {
    url: '',
    ext: '',
    disabled: false,
    width: 2000,
    height: 2000,
  },
  carousel_banner_data: [],
  enabled_carousel_banner_auto_play: false,
  duration_carousel_banner_auto_play: 5000,

  shown_categories: true,
  category_card_mobile: 'primary',
  category_card: 'primary',
  products_per_category_section: 5,
  shown_view_all_products_btn: true,
  type_layout_category_section: 'by_products',
  rows_per_category_section: 1,

  footer_bg_color: "", // ok
  footer_text_color: "#ffffff",

  nav_bg_color: "", // ok
  nav_menu_items_color: "#ffffff",

  facebook: {
    url: "",
    icon: ""
  },
  instagram: {
    url: "",
    icon: ""
  },
  tiktok: {
    url: "",
    icon: ""
  },
  custom_url: {
    url: "",
    icon: ""
  },

  home_description: {
    content: "",
    bg_image: "",
    bg_mode: "",
    bg_width: "",
    bg_height: "",
    bg_color: "",
    font_name: "",
    font_url: "",
    color: "",
  },
  home_story: {
    content: "",
    bg_image: "",
    bg_mode: "",
    bg_width: "",
    bg_height: "",
    bg_color: "",
    font_name: "",
    font_url: "",
    color: "",
  },

  logo: '',
  store_name: '',
  hidden_store_name: false,
  slug: '',
  font: '',
  font_name: '',

  root_layout_bg_color: "#fafafa",
  root_layout_bg_img: "",

  category_section: {
    name: {
      color: "",
      size: 30,
      font_name: "",
      font_url: "",
      decorator: "none",
      align: "center",
    }
  },

  colors_selection: {
    width: 50,
    height: 50,
    border_color: '',
    border_width: 0,
    size: 16,
    font_name: '',
    font_url: '',
    color: '#ffffff',
    decorator: 'none',
    label: {
      text: "Color",
      image: "",
      type: "text"
    }
  },

  sizes_selection: {
    width: 50,
    height: 50,
    size: 16,
    font_name: '',
    font_url: '',
    decorator: 'none',
    border_radius: null,
    selected: {
      border_color: '', // color primary
      border_width: 0,
      color: '#ffffff', // color base text
      bg_color: "", // color primary
    },
    unselected: {
      border_color: '', // color primary
      border_width: 1,
      color: '', // color primary
      bg_color: "#ffffff", // color white
    },
    label: {
      text: "Size",
      image: "",
      type: "text"
    }
  },
  product_price: {
    size: 24,
    font_name: "",
    font_url: "",
    color: "",
    decorator: "none",
    align: "left",
  },
  product_name: {
    size: 30,
    font_name: "",
    font_url: "",
    color: "",
    decorator: "none",
    align: "left",
  },
  quantity: {
    border_radius: 8,
    border_color: '#d9d9d9',
    border_width: 1,
    bg_color: "#ffffff",
    shown_controllers: true,

    size: 16,
    font_name: "",
    font_url: "",
    color: "",
    decorator: "none",
    align: "center",
    label: {
      text: "Quantity",
      image: "",
      type: "text"
    }
  },
  product_labels: {
    size: 16,
    font_name: "",
    font_url: "",
    color: "",
    decorator: "none",
  },
  root_layout_bg: {
    color: '#fafafa',
    image: '',
    mode: 'fill',
    width: 50,
    height: 50,
  },
  seo: {
    product: {
      og: {
        title: "{productName} | {storeName}",
        description: "A premium product from {storeName}",
        keywords: [],
        image: "",
        audio: "",
        videos: "",
        use_default: true,
        image_ext: "",
        audio_ext: "",
        videos_ext: "",
      },
      icon: {
        use_default: true,
        url: ""
      },
      shortcut: {
        url: ""
      },
      apple: {
        url: ""
      },
      other: {
        url: ""
      },
      app_links: {
        ios: {
          url: ""
        },
        android: {
          url: ""
        }
      }
    },
    category: {
      og: {
        title: "{categoryName} | {storeName}",
        description: "Browse the {storeName}'s store by {platformName}",
        keywords: [],
        image: "",
        audio: "",
        videos: "",
        use_default: true,
        image_ext: "",
        audio_ext: "",
        videos_ext: "",
      },
      icon: {
        use_default: true,
        url: ""
      },
      shortcut: {
        url: ""
      },
      apple: {
        url: ""
      },
      other: {
        url: ""
      },
      app_links: {
        ios: {
          url: ""
        },
        android: {
          url: ""
        }
      }
    },
    store: {
      og: {
        title: "Home | {storeName}",
        description: "Browse the {storeName}'s store by {platformName}",
        keywords: [],
        image: "",
        audio: "",
        videos: "",
        image_ext: "",
        audio_ext: "",
        videos_ext: "",
      },
      icon: {
        use_default: true,
        url: ""
      },
      shortcut: {
        url: ""
      },
      apple: {
        url: ""
      },
      other: {
        url: ""
      },
      app_links: {
        ios: {
          url: ""
        },
        android: {
          url: ""
        }
      }
    },
    app_links: {
      ios: {
        app_store_id: ""
      },
      android: {
        package: "",
        app_name: ""
      }
    },
    apple_web_app: {
      title: "",
      status_bar_style: "",
      start_up_image: "",
    }
  },
  platform_name: '',
  category_custom: '',
  store_id: '',
  is_my_merch: -1,
  used_fonts: [],
  popups: [],
  tms: {
    ga4: {
      id: ""
    }
  },
  supports: {
    phone: -1,
    email: -1
  },
  count_product: 0,
  count_category: 0,
  root_layout_promo_bar: {
    promo_id: "",
    bg_color: "#f8a151",
    color: "#000000",
    font_name: "",
    font_url: "",
    bg_image: "",
    bg_mode: "fill",
    bg_width: 50,
    bg_height: 50,
  },
}

export const parseStoreMeta = (personalStoreMetadata: any) => {
  // START: PARSE CAROUSEL BANNERS
  const _defaultStoreMeta = JSON.parse(JSON.stringify(defaultStoreMeta))
  const carouselBannerData = !!personalStoreMetadata.version
    ? parseJson(personalStoreMetadata.carousel_banner_data)
    : Array.isArray(personalStoreMetadata.carousel_banner_image)
      ? personalStoreMetadata.carousel_banner_image.map((url: any, idx: any) => ({
        link: personalStoreMetadata.carousel_banner_link[idx] || '',
        uid: personalStoreMetadata.carousel_banner_uid[idx] || `${+new Date()}`,
        url,
      }))
      : []
  // END: PARSE CAROUSEL BANNERS

  const fieldNames = Object.keys(_defaultStoreMeta)
  const formatedData: any = fieldNames.reduce((obj: any, fieldName) => {
    if (typeof personalStoreMetadata[fieldName] === 'string') {
      obj[fieldName] = personalStoreMetadata[fieldName] === undefined
        ? _defaultStoreMeta[fieldName].replace("mpodx.shop", 'static.mpodx.com/old-image')
        : parseJson(personalStoreMetadata[fieldName].replace("mpodx.shop", 'static.mpodx.com/old-image'))
    } else {
      obj[fieldName] = personalStoreMetadata[fieldName] === undefined
        ? _defaultStoreMeta[fieldName]
        : personalStoreMetadata[fieldName]
    }

    return obj
  }, {})

  if (typeof formatedData.banner !== 'object') {
    formatedData.banner = {
      ..._defaultStoreMeta.banner,
      url: personalStoreMetadata.banner || '',
      ext: personalStoreMetadata.banner_ext || '',
      disabled: personalStoreMetadata.disabled_banner || false,
    }
  }
  if (typeof formatedData.banner_mobile !== 'object') {
    formatedData.banner_mobile = {
      ..._defaultStoreMeta.banner_mobile,
      url: personalStoreMetadata.banner_mobile || '',
      ext: personalStoreMetadata.banner_mobile_ext || '',
      disabled: personalStoreMetadata.disabled_banner_mobile || false,
    }
  }
  if (typeof formatedData.banner_1920x1080 !== 'object') {
    formatedData.banner_1920x1080 = {
      ..._defaultStoreMeta.banner_1920x1080,
      url: personalStoreMetadata.banner_1920x1080 || '',
      ext: personalStoreMetadata.banner_1920x1080_ext || '',
      disabled: personalStoreMetadata.disabled_banner_1920x1080 || false,
    }
  }

  const storeIcon = !!personalStoreMetadata.version
    ? formatedData.seo.store.icon.url || formatedData.logo
    : personalStoreMetadata.logo

  let storeOgImage = !!personalStoreMetadata.version
    ? formatedData.seo.store.og.image
    : personalStoreMetadata.ogImage

  let storeOgExt = !!personalStoreMetadata.version
    ? formatedData.seo.store.og.image_ext
    : ""

  if (!storeOgImage) {
    storeOgImage = formatedData.banner?.url || formatedData.banner_mobile?.url || formatedData.banner_1920x1080?.url || carouselBannerData.find((banner: any) => !!banner.url)?.url
    storeOgExt = formatedData.banner?.ext || formatedData.banner_mobile?.ext || formatedData.banner_1920x1080?.ext || ""
  }

  const values = {
    ...formatedData,
    seo: {
      ...formatedData.seo,
      store: {
        ...formatedData.seo.store,
        icon: {
          ...formatedData.seo.store.icon,
          url: storeIcon
        },
        og: {
          ...formatedData.seo.store.og,
          image: storeOgImage,
          image_ext: storeOgExt
        }
      }
    },
    version: "1",
    carousel_banner_data: carouselBannerData
  }

  if (!values.sizes_selection.selected) {
    values.sizes_selection.selected = _defaultStoreMeta?.sizes_selection?.selected
  }

  if (!values.sizes_selection.unselected) {
    values.sizes_selection.unselected = _defaultStoreMeta?.sizes_selection?.unselected
  }

  if (typeof personalStoreMetadata.about_text === 'string') {
    values.about = {
      ..._defaultStoreMeta.about,
      content: personalStoreMetadata.about_text
    }
  }

  if (typeof values.home_description === 'string') {
    values.home_description = {
      ..._defaultStoreMeta.home_description,
      content: values.home_description
    }
  }

  const homeStory = !!personalStoreMetadata.version
    ? formatedData.home_story
    : formatedData.home_bottom_description

  if (typeof homeStory === 'string') {
    values.home_story = {
      ..._defaultStoreMeta.home_story,
      content: homeStory
    }
  }

  values.product_card_text_color = values.product_card_text_color || values?.theme?.color_text
  values.btn_view_product_bg_color = values.btn_view_product_bg_color || values?.theme?.color_primary
  values.footer_bg_color = values.footer_bg_color || values?.theme?.color_primary
  values.nav_bg_color = values.nav_bg_color || values?.theme?.color_primary

  values.product_price.color = values.product_price.color || values?.theme?.color_text
  values.product_name.color = values.product_name.color || values?.theme?.color_text
  values.product_labels.color = values.product_labels.color || values?.theme?.color_text

  values.btn_view_product_text_color = values.btn_view_product_text_color || _defaultStoreMeta.btn_view_product_text_color
  values.footer_text_color = values.footer_text_color || _defaultStoreMeta?.footer_text_color
  values.nav_menu_items_color = values.nav_menu_items_color || _defaultStoreMeta?.nav_menu_items_color

  values.colors_selection.color = values.colors_selection.color || values.colors_selection.color

  values.sizes_selection.selected.bg_color = values.sizes_selection.selected.bg_color || values?.theme?.color_primary
  values.sizes_selection.selected.color = values.sizes_selection.selected.color || _defaultStoreMeta.sizes_selection.selected.color
  values.sizes_selection.selected.border_color = values.sizes_selection.selected.border_color || values?.theme?.color_primary

  values.sizes_selection.unselected.color = values.sizes_selection.unselected.color || values?.theme?.color_text
  values.sizes_selection.unselected.border_color = values.sizes_selection.unselected.border_color || values?.theme?.color_primary

  values.theme.border_radius = values.theme.border_radius || _defaultStoreMeta?.theme.border_radius

  values.card_product = !!personalStoreMetadata.version ? values.card_product : values.card_product === 'primary' ? 'secondary' : 'primary'

  if (values.supports?.email === -1) {
    values.supports.email = getDefaultSupportEmail(personalStoreMetadata)
  }

  if (values.supports?.phone === -1) {
    values.supports.phone = ""
  }

  const categoryCard = !!personalStoreMetadata.version
    ? values.category_card
    : _defaultStoreMeta.category_card

  const categoryCardMobile = !!personalStoreMetadata.version
    ? values.category_card_mobile
    : personalStoreMetadata.category_card_mobile

  const facebook = typeof values.facebook === 'string' || !values.facebook
    ? {
      url: values.facebook,
      icon: ""
    }
    : values.facebook

  const instagram = typeof values.instagram === 'string' || !values.instagram
    ? {
      url: values.instagram,
      icon: ""
    }
    : values.instagram

  const tiktok = typeof values.tiktok === 'string' || !values.tiktok
    ? {
      url: values.tiktok,
      icon: ""
    }
    : values.tiktok

  return {
    ...values,
    tiktok,
    facebook,
    instagram,
    category_card: categoryCard,
    category_card_mobile: categoryCardMobile,
    home_description: {
      ...values.home_description,
      hasContent: !(!values.home_description?.content || values.home_description?.content === '<p></p>')
    },
    home_story: {
      ...values.home_story,
      hasContent: !(!values.home_story?.content || values.home_story?.content === '<p></p>')
    },
    about: {
      ...values.about,
      hasContent: !(!values.about?.content || values.about?.content === '<p></p>')
    },
    colors_selection: {
      ...values.colors_selection,
      label: {
        ..._defaultStoreMeta.colors_selection.label,
        ...values.colors_selection.label
      }
    },
    sizes_selection: {
      ...values.sizes_selection,
      label: {
        ..._defaultStoreMeta.sizes_selection.label,
        ...values.sizes_selection.label
      }
    }
  }
}